var exports = {
  "h_": "middlePaneWrapper__5bOwtP",
  "e": "milestoneDetailsWrapper__5ejR4e",
  "h5": "status__FgX6Aq",
  "VJ": "listMetadataContainer__5mBxGt",
  "aI": "listMetadata__9yIKUF",
  "bf": "listProgressSection__ec6lng",
  "hr": "progressBar__BBCOfM",
  "qB": "progress__KUgGtB",
  "AQ": "menuButton__1B5lz9",
  "NE": "progressSection__8MuAux",
  "gQ": "progressPercentage__tFc4lS",
  "Vl": "overDue__tvzKhi",
  "oB": "tabsContainer__v02__z",
  "kj": "buttonGrp__roS2io",
  "wx": "header__gv1TLG",
  "i8": "titleGroup__uhsp0H",
  "PO": "actionsGrp__eNTOog",
  "cv": "milestoneListWrapper__jyuNdJ",
  "I1": "milestoneDataContainer__XjkAhL",
  "_k": "middot__PLIQfH",
  "jQ": "milestoneIssueCount__E2u_-c",
  "P4": "milestoneRow__l1JaZo",
  "Z5": "listItemContent__dFYXhZ",
  "hC": "listDescription__G-jl8f",
  "MV": "listDateContainer__HAVX8b",
  "x": "milestoneData__zWRYE1",
  "B3": "milestoneStatus__WGfa4M",
  "nz": "milestoneDescription__ihIshT",
  "SV": "optimisticDescription__PxaD0S",
  "it": "mdViewer__SFyZij",
  "yZ": "collapsed__m7fwYb",
  "sz": "expanded__JkFRwQ",
  "Jk": "showMoreButtonContainer__WeP49C",
  "x6": "button__EoIA7b",
  "nl": "dialogTitle__fM10VB",
  "kr": "dialogDescriptionContainer__OWkebN",
  "HP": "dialogDescription__FRM5_o",
  "an": "errorFallbackContainer__7J2mZs",
  "oN": "deleteMilestoneButton__lLtVhX",
  "nf": "link__vd_MRV",
  "R_": "heading__YjqGtZ",
  "w7": "milestoneTitleWrapper__HW_ktt",
  "Sl": "backLink__SzncY3",
  "DD": "title__GpAvTS",
};

module.exports = exports;
